import React, { Fragment,Component } from 'react';
import logo from '../images/about_banner.png';

class aboutus extends Component {
    render() {
        return (
            <Fragment>
                <div className='img-container'>
                  <img src={logo} alt="about"/>
                </div>
                <div className="body-container">
                    <br/>
                    <div className="CenteredTitle">“I like breaking things!”</div>
                    <br/>
                    <div className="text-center">
                    Join me in taking it apart and putting back together and making it better.<br/> 
                    A love for computer science, technology and design has driven me to look for ways to improve on the development process and search for ways to make it more efficient. <br/>
                    Join me on my journey to push the limits and discover what makes things work, what their vulnerabilities are and all of the different ways we can improve on quality! 
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default aboutus



// WEBPACK FOOTER //
// ./src/components/layout/aboutus.js